// Import Dependencies
import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';

import CouponBanner from '~/common/components/CouponBanner';
import FreeTrialSMSBanner from '~/common/components/FreeTrialSMSBanner';
import Header from '~/common/components/Header';
// Import Components
import LoadingSpinner from '~/common/components/LoadingSpinner';
import { withRouter } from 'react-router-dom';
// Import Stylesheet
import styles from './maxWidth.css';

@withRouter
@inject('numberLockSessionStore', 'userLocationStore')
@observer
export default class MaxWidthLayout extends Component {
    render() {
        const { NLS } = this.props.numberLockSessionStore;
        const { pathname } = this.props.history.location;
        const { isSignupAllowed } = this.props.userLocationStore;
        return (
            <div className={styles.max}>
                <FreeTrialSMSBanner />
                <Header headerType={pathname} />
                {isSignupAllowed && <Fragment>
                    <CouponBanner />
                </Fragment>
                }
                {NLS
                    ?
                    this.props.children
                    :
                    // loading spinner
                    <div className={styles.initialLoading}>
                        <LoadingSpinner />
                    </div>
                }
            </div>
        );
    }
}
